import React, { useState, useEffect } from 'react'
import { formatCurrency } from '../../utilities.js';
import { ReservationTimer } from './reservation_timer.jsx';
import { Cart } from './cart';
import { ComplianceForm } from './compliance_form.jsx';

export const ConfirmOrder = ({
  stripe,
  elements,
  cart,
  loading,
  currency,
  onSubmit,
  onCancel,
  onGoBack,
  now,
  reservation_ends_at,
  browser_time_offset,
  compliance_level,
  compliance_text,
  registrant_terms_url,
  platform_name,
  payment_instructions,
  payment_instructions_free,
  payout_account_type,
  payment_intent_client_secret,
  payment_intent_confirmation_token,
}) => {
  const [isLoading, setIsLoading] = useState(loading);
  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const [errors, setErrors] = useState({
    provider: null,
    order: null,
    agreement: null,
  });
  const initialAgreementState = compliance_level === 'none' || compliance_level === 'light';
  const [agreementState, setAgreementState] = useState(initialAgreementState);

  const onAgreementStateChange = (event) => {
    setAgreementState(event.target.checked);
  };

  const handleStripePayment = async () => {
    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrors((prev) => ({
        ...prev,
        provider: submitError.message,
      }));
      setIsLoading(false);
      return false;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      clientSecret: payment_intent_client_secret,
      redirect: 'if_required',
      confirmParams: {
        confirmation_token: payment_intent_confirmation_token,
      }
    });

    if (error) {
      setErrors((prev) => ({
        ...errors,
        provider: error.message,
      }));
      setIsLoading(false);
      return false;
    }

    setErrors((prev) => ({
      ...errors,
      stripe: null,
    }));

    setIsLoading(false);
    return paymentIntent;
  };

  const onConfirmOrderSubmit = async (event) => {
    event.preventDefault();

    if (isLoading || loading) {
      return;
    }

    // Clear errors
    setErrors({
      ...errors,
      provider: null,
      order: null,
      agreement: null,
    });

    setIsLoading(true);

    // Validate form
    if (!agreementState) {
      setErrors({
        ...errors,
        agreement: 'required',
      });
      setIsLoading(false);
      return;
    }

    // For Stripe payments, confirm the payment
    let paymentIntentId = null;
    if (cart.total > 0 && payout_account_type === 'stripe' && payment_intent_client_secret !== null) {
      const paymentIntent = await handleStripePayment();
      if (!paymentIntent) {
        return;
      }

      paymentIntentId = paymentIntent.id;
    }

    // Submit form
    onSubmit({
      agreement_state: agreementState,
      payment_intent: paymentIntentId,
    });
  };

  let submitLabel = 'Register';
  if (loading || isLoading) {
    submitLabel = 'Processing...';
  } else if (cart.total > 0) {
    submitLabel = `Pay ${formatCurrency(cart.total, currency)}`;
  }

  const paymentInstructionText =
    cart.total > 0 ? payment_instructions : payment_instructions_free;

  return (
    <div className="widget-content">
      <ReservationTimer
        now={now}
        reservationEnds={reservation_ends_at}
        browserTimeOffset={browser_time_offset}
      />

      <form className="car_form form-sidebar" onSubmit={onConfirmOrderSubmit}>
        <span className="em-section_register_title">Confirm Registration</span>

        <Cart
          items={cart.items}
          fee={cart.fee}
          tax={cart.tax}
          total={cart.total}
          currency={currency}
        />

        <ComplianceForm
          level={compliance_level}
          agreementState={agreementState}
          termsUrl={registrant_terms_url}
          platformName={platform_name}
          onAgreementChange={onAgreementStateChange}
          errors={errors.agreement}
          text={compliance_text}
        />

        {!!paymentInstructionText && (
          <div className="payment-instructions-wrap">
            <p>{paymentInstructionText}</p>
          </div>
        )}


        {/* Generic errors, either from the provider... */}
        {errors.provider && (
          <div className="payment-provider-error">
            <p>{errors.provider}</p>
          </div>
        )}

        {/* about the order in general... */}
        {errors.order && (
          <div className="payment-provider-error">
            <p>{errors.order}</p>
          </div>
        )}

        <div className="action_button">
          <a
            href="#"
            className="cancel_link em-link"
            onClick={onGoBack}
          >
            Back
          </a>
          <a
            href="#"
            className="cancel_link em-link"
            onClick={onCancel}
          >
            Cancel
          </a>
          <button
            type="submit"
            className="em-button em-primary"
          >
            {submitLabel}
          </button>
        </div>
      </form>
    </div>
  );
};
